export enum WorkplaceStatusOrderRelation {
    NOT_RELATED = 'NOT_RELATED',
    ORDER_NOT_PRESENT = 'ORDER_NOT_PRESENT',
    ORDER_PRESENT = 'ORDER_PRESENT'
}
